<div
    [iqStyleProcessorClassname]="containerClasses()"
    [cssClassRules]="cssClassRules()" 
    [attr.data-testid]="id"
    [attr.data-styleTarget]="id"
>
    @if(fg$ | async){}
    <ng-container *ngTemplateOutlet="controlTemplate"></ng-container>
</div>

<ng-template #controlTemplate>
    @for (control of currentControls(); track control.id; let i = $index){
    <iq-style-processor-show-element
        [id]="control.id + '-style-processor'"
        [iqStyleProcessorClassname]="control.classes"
        [cssClassRules]="control.cssClassRules"
        [rules]="control.rules || []"
    >
        <div
            [attr.data-testId]="control.id + '-container'"
            [attr.data-styleTarget]="control.id"
        >
            @switch (control.type) { @case ('Select') {
            <datiq-select
                [id]="control.id"
                [settings]="control | controlLegacySelect"
                [formGroup]="fg"
                (optionSelected)="change('control', control, 'value', $event)"
                (multiSelected)="change('control', control, 'value', $event)"
                [customErrorMessage]="control.customErrorMessage"
            ></datiq-select>
            } @case('Action'){
            <iq-controls-action-button
                [id]="control.id"
                [label]="control.label"
                [fg]="fg"
            >
            </iq-controls-action-button>
            } @case('Tabs'){
            <iq-control-tab-tabs
                [id]="control.id"
                [tabs]="control.tabs"
                [value]="control.value"
                [fg]="fg"
                [name]="control.name"
            ></iq-control-tab-tabs>
            }@case('Text') {
            <iq-control-text-text
                [id]="control.id"
                [disabled]="control.disabled"
                [fg]="fg"
                [name]="control.name"
                [value]="control.value"
                [required]="control.required"
                (changed)="change('control', control, 'value', $event)"
            ></iq-control-text-text>
            } @case('Label'){
            <iq-controls-label
                [id]="control.id"
                [label]="control.label"
            ></iq-controls-label>
            }@case('Percent') {
            <iq-control-text-percent
                [id]="control.id"
                [disabled]="control.disabled"
                [fg]="fg"
                [name]="control.name"
                (changed)="change('control', control, 'value', $event)"
                (keyupped)="keyUp('control', control, 'value', $event)"
                [minValue]="control.minValue || 0"
                [maxValue]="control.maxValue || 1"
            ></iq-control-text-percent>
            } @case('Integer') {
            <iq-control-text-integer
                [id]="control.id"
                [disabled]="control.disabled"
                [fg]="fg"
                [name]="control.name"
                (changed)="change('control', control, 'value', $event)"
                [minValue]="control.minValue || 0"
                [maxValue]="control.maxValue || 9999"
            ></iq-control-text-integer>
            }@case('Currency'){
            <iq-control-text-currency
                [id]="control.id"
                [disabled]="control.disabled"
                [fg]="fg"
                [name]="control.name"
                (changed)="change('control', control, 'value', $event)"
                [minValue]="control.minValue || 0"
                [maxValue]="control.maxValue || 9999"
                [suffix]="control.suffix"
                [prefix]="control.prefix"
                (keyupped)="keyUp('control', control, 'value', $event)"
            ></iq-control-text-currency>
            }@case ('Geo') {
            <iq-control-text-geo
                [id]="control.id"
                [label]="control.label"
                [disabled]="control.disabled"
                [required]="control.required"
                [fg]="fg"
                [name]="control.name"
                [value]="control.value"
                (searching)="search('control', control, 'isSearching', $event)"
                (changed)="change('control', control, 'value', $event)"
                (submitted)="submit('control', control)"
                (loaded)="load('control', control, 'value', $event)"
                [customErrorMessage]="control.customErrorMessage"
                [locationErrorMessage]="control.locationErrorMessage"
                [startFocused]="control.startFocused"
            ></iq-control-text-geo>
            }@case('Reset'){
            <iq-controls-reset-button
                [id]="control.id"
                [fg]="fg"
                [label]="control.label"
                (resetted)="reset('control', control, 'initialValue', $event)"
            ></iq-controls-reset-button>
            }@case('Checkbox'){
            <iq-control-checkbox-control
                [id]="id"
                [name]="control.name"
                [checkedLabel]="control.checkedLabel"
                [uncheckedLabel]="control.uncheckedLabel"
                [tooltipHeader]="control.tooltipHeader"
                [tooltipBody]="control.tooltipBody"
                [fg]="fg"
                [value]="control.value"
                [disabled]="control.disabled"
            ></iq-control-checkbox-control>
            }@case('Submit'){

            <iq-controls-submit-button
                [id]="control.id"
                [fg]="fg"
                [label]="control.label"
                [disabled]="control.disabled"
                (submitted)="submit('control', control)"
            ></iq-controls-submit-button>
            }@case('Panel'){

            <iq-controls-control-panel-wrapper
                [id]="control.id"
                [name]="control.name"
                [controls]="control.controls"
                [fg]="fg"
                [formClasses]="control.formClasses"
                [panelClasses]="control.panelClasses"
                [isDisabled]="control.disabled"
                [isEdited]="control.isEdited"
                [disabledLabel]="control.disabledLabel"
                [closedLabel]="control.closedLabel"
                [openLabel]="control.openLabel"
                (changed)="change('control', control, 'value', $event)"
                (submitted)="submit('control', control)"
                (opened)="open()"
                (closed)="close()"
            ></iq-controls-control-panel-wrapper>
            }@default { } }
        </div>
    </iq-style-processor-show-element>
    }
</ng-template>
